import React from 'react';
import {colors} from '../theme/colors';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false, error: null, errorInfo: null};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    // Ignore audio playback errors - they're not critical
    if (error && error.message && error.message.includes('play() request was interrupted')) {
      console.warn('Audio playback error (non-critical):', error.message);
      return; // Don't show error screen for audio issues
    }
    
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      const errorMessage = this.state.error ? this.state.error.toString() : 'Unknown error';
      const errorStack = this.state.errorInfo ? this.state.errorInfo.componentStack : 'No stack trace';
      
      return (
        <div style={styles.container}>
          <div style={styles.scrollView}>
            <div style={styles.title}>⚠️ Error</div>
            <div style={styles.message}>{errorMessage}</div>
            <div style={styles.subtitle}>Stack Trace:</div>
            <div style={styles.stack}>{errorStack}</div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    flex: 1,
    backgroundColor: colors.bg,
    padding: 20,
    minHeight: '100vh',
    overflowY: 'auto',
  },
  scrollView: {
    flex: 1,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colors.error,
    marginBottom: 20,
  },
  message: {
    fontSize: 16,
    color: colors.textPrimary,
    marginBottom: 20,
    padding: 10,
    backgroundColor: colors.surface,
    borderRadius: 8,
  },
  subtitle: {
    fontSize: 14,
    color: colors.primary,
    marginTop: 20,
    marginBottom: 10,
    fontWeight: '600',
  },
  stack: {
    fontSize: 10,
    color: colors.textTertiary,
    fontFamily: 'monospace',
    backgroundColor: colors.surface,
    padding: 10,
    borderRadius: 8,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
};

export default ErrorBoundary;
